import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    sidebarShareFunc
} from "./common/_sidebarShare";
import {
    sidebarTocFunc
} from "./common/_sidebarToc";
import {
    homeFunc
} from "./pages/_home";

$(function () {
    // DOM 構築直後に目次だけ先に実行（ほか初期化エラーでも空のままになりにくい）
    sidebarTocFunc();
});

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    sidebarShareFunc();
    homeFunc();
});
